import { useAppSelector } from "../../config/hooks";
import { TIMEZONE, TIME_FORMAT } from "../../config/helper";
import { useHistory } from "react-router-dom";
import backgroundImage from "../../assets/images/background-room-showcase.jpg";
import logo from "../../assets/images/havefun-logo.png";
import styles from "./Confirmation.module.css";
import greenTickIcon from "../../assets/icons/green_tick_icon.svg";
import Loader from "../../components/loader/Loader";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetApp } from "./ConfirmationSlice";
import moment from "moment-timezone";

const Confirmation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const confirmation = useAppSelector(
    (state) => state.confirmation.confirmation
  );
  const isLoading = useAppSelector((state) => state.app.isLoading);

  if (!isLoading && !!!confirmation.appointmentUuid) history.push("/home");

  const handleBackOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.push("/home");
  };

  const handleHomeOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    window.location.href = "https://havefunkaraoke.com/home/";
  };

  const bgStyle = {
    background: `lightgray url(${backgroundImage}) 50% / cover no-repeat`,
    display: "flex",
    FlexDirection: "column",
    minHeight: "100vh",
    alignItems: "stretch",
  };

  useEffect(() => {
    return () => {
      dispatch(resetApp());
    };
  }, []);

  return (
    <div className={styles.Page} style={bgStyle}>
      <div className={styles.PageContainer}>
        <div className={styles.Container}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img alt="HaveFun Logo" src={logo} width={120} />
          </div>
          {!isLoading ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "40px",
                  marginBottom: "40px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  alt="Green Tick"
                  src={greenTickIcon}
                  width="20px"
                  style={{ margin: "0 20px 0 0" }}
                />
                <span style={{ fontWeight: "700" }}>
                  You've successfully made a booking
                </span>
              </div>
              {/* <div className={styles.Description}>
                <div className={styles.Left}>Booking ID</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>
                  e9bf3f59-9757-476e-a9fe-e232dab2ded5
                </div>
              </div> */}

              <div className={styles.Description}>
                <div className={styles.Left}>Outlet</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>{confirmation.outlet}</div>
              </div>

              <div className={styles.Description}>
                <div className={styles.Left}>Room Type</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>{confirmation.roomType}</div>
              </div>

              <div className={styles.Description}>
                <div className={styles.Left}>Duration</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>
                  {confirmation.duration} hours
                </div>
              </div>

              <div className={styles.Description}>
                <div className={styles.Left}>Date</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>
                  {moment(confirmation.startTime)
                    .tz(TIMEZONE)
                    .toDate()
                    .toDateString()}
                </div>
              </div>

              <div className={styles.Description}>
                <div className={styles.Left}>Time</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>
                  {moment(confirmation.startTime)
                    .tz(TIMEZONE)
                    .format(TIME_FORMAT)}{" "}
                  -{" "}
                  {moment(confirmation.endTime)
                    .tz(TIMEZONE)
                    .format(TIME_FORMAT)}
                </div>
              </div>

              <div className={styles.Description}>
                <div className={styles.Left}>Phone</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>
                  <div>{confirmation.phone}</div>
                </div>
              </div>

              <div className={styles.Description}>
                <div className={styles.Left}>Name</div>
                <div style={{ width: "10px" }}>:</div>
                <div className={styles.Right}>{confirmation.name}</div>
              </div>

              <button className={styles.Button} onClick={handleHomeOnClick}>
                Back to Homepage
              </button>
              <button className={styles.BookButton} onClick={handleBackOnClick}>
                Make another booking
              </button>
              <br />
            </>
          ) : (
            <div style={{ marginTop: "100px" }}>
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
